export default "__VITE_PUBLIC_ASSET__47e89072__"